import { useState, type SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

/**
 * Mimi Wheel pubblica: la copia dell'artifact (public/mimi-wheel) in sola lettura, che segue in diretta la regia
 * dell'area riservata. L'iframe occupa tutto lo schermo; in cima lascia una fascia trasparente sotto cui si vede
 * l'header del sito. Appena si scorre passa sopra l'header (z-50): «Si parte» lo copre e la ruota copre «Si parte».
 */
export function MimiWheel() {
  const { t } = useTranslation()
  const [isScrolled, setIsScrolled] = useState(false)

  // Stesso dominio: si ascolta lo scroll dentro l'iframe; il listener sparisce con la pagina dell'iframe.
  function handleLoad(event: SyntheticEvent<HTMLIFrameElement>) {
    const frame = event.currentTarget.contentWindow
    if (!frame) return
    const update = () => setIsScrolled(frame.scrollY > 0)
    frame.addEventListener('scroll', update, { passive: true })
    update()
  }

  return (
    <main id="main">
      <h1 className="sr-only">{t('mimiWheel.title')}</h1>
      <iframe
        src="/mimi-wheel/index.html"
        title={t('mimiWheel.aria')}
        allow="autoplay"
        onLoad={handleLoad}
        className={cn('fixed inset-0 block h-dvh w-full border-0', isScrolled ? 'z-[60]' : 'z-30')}
      />
    </main>
  )
}
